module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-69.400bff23.svg";